const socialNetworks: any = {
  vk_url: 'https://vk.com/cdtocenter',
  telegram_url: 'https://t.me/CDTOonline'

}

export { socialNetworks }
